import * as moment from 'moment';

export const timeHelper = (time) => {
    const today = new Date().getTime();
    const secToday =  today / 1000;
    const res = secToday - time;    
  
    const date = moment.duration(res,"s").humanize({precise:true});
    
    return date;
};
